import React, { useEffect, useState } from "react";
import Header from "../master/SideBar.jsx";
import Nav from "../master/NavBar.jsx";
import { SweetAlertShow, LoadingDiv } from "../master/Master.jsx";
import Master from "./Master.jsx";
import { Link } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink.js";

import { courseList } from "../../api/Courses.js";
import { batchList } from "../../api/Batch.js";
import Pagination from "../components/Pagination.jsx";
import { feeDepositListV4 } from "../../api/FeesDeposite.js";
import FollowUpModal from "./FollowUpModel.jsx";
import { getFollowupsList } from "../enquiry/components/Master.jsx";
import { printElement } from "../master/Print.jsx";

export default function FeeCollectionV4() {
  const hasAccess = usePrivateLink();
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [batches, setBatches] = useState([]);
  const [courses, setCourses] = useState([]);
  const [modelData, setModelData] = useState([]);

  const handleFunction = () => {
    getFollowupsList({
      setLoading,
      filters,
      setData,
    });
  };

  useEffect(() => {
    handleFunction();
  }, [filters]);

  const getBatchList = async () => {
    setLoading(true);
    try {
      let addUrl = ``;
      if (filters?.course_id) {
        addUrl += `course_id=${filters?.course_id}`;
      }
      if (filters?.session_id) {
        addUrl += `session_id=${filters?.session_id}`;
      }
      const response = await batchList(addUrl);

      if (response.data.status) {
        setBatches(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatchList();
  }, [filters?.course_id, filters?.session_id]);

  const courseFetch = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
  }, []);

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  const getStudents = async () => {
    try {
      setLoading(true);
      let url = "";
      Object.entries(filters).forEach(([key, value]) => {
        if (value && key) {
          url += `${key}=${value}&`;
        }
      });
      const response = await feeDepositListV4(url);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        setData([]);
      }
    } catch (err) {
      setData([]);
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudents();
    if (
      filters?.search?.length > 0 ||
      filters?.batch_id ||
      filters?.session_id
    ) {
      getStudents();
    }
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-md-12 right-pane">
                    <div className="card p-3 mb-3 shadow-sm border-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            style={{
                              width: 45,
                              height: 45,
                              borderRadius: "12px",
                              background:
                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i className="ri-money-rupee-circle-line"></i>
                          </div>

                          <div>
                            <h5 className="m-0 fw-bold">Fee Deposit</h5>
                            <small>Due Fees & Student Followups </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          <div className="d-flex flex-wrap gap-2 mb-3">
                            {/* SESSION */}
                            {filters.session_id && (
                              <span className="badge bg-primary-subtle text-primary px-3 py-2">
                                Session:{" "}
                                {
                                  sessions.find(
                                    (s) => s.id == filters.session_id,
                                  )?.session
                                }
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, session_id: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* SEARCH */}
                            {filters.search && (
                              <span className="badge bg-dark-subtle text-dark px-3 py-2">
                                Search: {filters.search}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, search: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* BATCH */}
                            {filters.batch_id && (
                              <span className="badge bg-warning-subtle text-dark px-3 py-2">
                                Batch:{" "}
                                {
                                  batches.find((b) => b.id == filters.batch_id)
                                    ?.title
                                }
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, batch_id: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* DATE RANGE */}
                            {filters.start_date && (
                              <span className="badge bg-info-subtle text-info px-3 py-2">
                                From: {filters.start_date}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, start_date: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {filters.end_date && (
                              <span className="badge bg-info-subtle text-info px-3 py-2">
                                To: {filters.end_date}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, end_date: "" })
                                  }
                                ></i>
                              </span>
                            )}
                          </div>

                          <button
                            title="Open Filters"
                            className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#filterCanvas"
                            style={{ width: 40, height: 40 }}
                          >
                            <i className="ri-filter-3-line text-primary"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card border-0 shadow-sm p-2">
                      <div className="card-body p-0">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          {/* Left Text */}
                          <h5 className="mb-0 fw-bold">
                            {/* Student Due Fees */}
                          </h5>

                          {/* Right Input */}
                          <div style={{ width: "350px" }}>
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Student Name/Mobile/Registration"
                                value={filters?.search}
                                onChange={(e) => {
                                  let value = e.target.value.toUpperCase();
                                  setFilters({ ...filters, search: value });
                                }}
                              />
                              <label>Name/Mobile/Reg. No</label>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive" id="printDiv" >
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Batch</th>
                                <th>All Session</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.data?.length > 0 ? (
                                data?.data?.map((student, index) => {
                                  return (
                                    <tr key={student?.id}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <Link
                                          to={`/student/details?id=${student?.student_info?.id}`}
                                          className="fw-semibold"
                                        >
                                          {student?.student_info?.name ?? ""}
                                        </Link>
                                      </td>
                                      <td>
                                        {student?.student_info?.phone ?? ""}
                                      </td>
                                      <td>{student?.batch?.title ?? "-"}</td>
                                      <td className="small">
                                        {Object.entries(student?.summary || {})
                                          .filter(
                                            ([_, data]) =>
                                              Number(data?.total ?? 0) > 0,
                                          )
                                          .map(([name, data], index) => (
                                            <div
                                              key={index}
                                              className="d-flex align-items-center gap-3"
                                            >
                                              <div className="fw-semibold text-dark text-nowrap text-capitalize">
                                                {name.replace("_", " ")} Fees :
                                              </div>
                                              <div className="d-flex align-items-center gap-2 flex-nowrap">
                                                <span className="text-primary fw-semibold text-nowrap">
                                                  ₹
                                                  {Number(
                                                    data?.total ?? 0,
                                                  ).toFixed(2)}
                                                </span>
                                                <span className="text-success fw-semibold text-nowrap">
                                                  ₹
                                                  {Number(
                                                    data?.paid ?? 0,
                                                  ).toFixed(2)}
                                                </span>
                                                <span className="text-danger fw-semibold text-nowrap">
                                                  ₹
                                                  {Number(
                                                    data?.pending ?? 0,
                                                  ).toFixed(2)}
                                                </span>
                                              </div>
                                            </div>
                                          ))}
                                      </td>

                                      <td className="text-center py-2">
                                        <div className="d-flex justify-content-center gap-2">
                                          <Link
                                            to={`/student/fees/deposit?id=${student?.student_id}`}
                                            className="btn btn-sm text-success bg-success-subtle border"
                                          >
                                            <i className="ri-money-rupee-circle-line"></i>
                                          </Link>

                                          <button
                                            className="btn btn-sm text-warning bg-warning-subtle border"
                                            data-bs-toggle="modal"
                                            data-bs-target="#feefollowup"
                                            onClick={() => {
                                              setModelData({
                                                data: student,
                                                student: student?.student_info,
                                                followups:
                                                  student?.student_info
                                                    ?.followups,
                                              });
                                            }}
                                          >
                                            <i className="ri-customer-service-2-line"></i>
                                            {/* FollowUp */}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    className="text-center py-4 text-danger"
                                  >
                                    No matching filter data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          <Pagination
                            data={data}
                            setFilters={setFilters}
                            filters={filters}
                          />

                          <FollowUpModal
                            data={modelData}
                            setLoading={setLoading}
                            handleFunction={handleFunction}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
        {/* HEADER */}
        <div className="offcanvas-header">
          <h5 className="offcanvas-title"> Filters</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        {/* BODY */}
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="form-floating form-floating-outline ">
                <select
                  className="form-select"
                  value={filters?.session_id}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      session_id: e.target.value,
                    });
                  }}
                >
                  <option value="all">All</option>
                  {sessions.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.session}:
                      {Number(item.status) === 1 ? "Active" : "Inactive"}
                    </option>
                  ))}
                </select>
                <label>Filter Session</label>
              </div>
            </div>
            <div className="col-12 mb-3">
              <div className="form-floating form-floating-outline ">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Student Name/Mobile/Registration"
                  value={filters?.search}
                  onChange={(e) => {
                    let value = e.target.value.toUpperCase();
                    setFilters({ ...filters, search: value });
                  }}
                />
                <label>Name/Mobile/Reg. No</label>
              </div>
            </div>

            <div className="col-12 mb-3">
              <div className="form-floating form-floating-outline ">
                <select
                  className="form-select"
                  value={filters?.course_id}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      course_id: e.target.value,
                      batch_id: "",
                    });
                  }}
                >
                  <option value="">All Courses / Classes</option>
                  {courses?.map((course, index) => (
                    <option key={index} value={course.id}>
                      {course.title}
                    </option>
                  ))}
                </select>
                <label>Course</label>
              </div>
            </div>

            <div className="col-12 mb-3">
              <div className="form-floating form-floating-outline ">
                <select
                  className="form-select"
                  value={filters?.batch_id}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      batch_id: e.target.value,
                    });
                  }}
                >
                  <option value="">Select Batch</option>
                  {batches?.map((batch, i) => {
                    const courseTitle = batch?.course?.title || "";
                    const shortCourseTitle =
                      courseTitle.length > 20
                        ? courseTitle.substring(0, 20) + "..."
                        : courseTitle;

                    return (
                      <option key={i} value={batch?.id}>
                        {`${batch?.title} (${shortCourseTitle})`}
                      </option>
                    );
                  })}
                </select>
                <label>Select Batch</label>
              </div>
            </div>

            <div className="col-12 mb-3">
              <div className="form-floating form-floating-outline ">
                <input
                  type="date"
                  className="form-control"
                  value={filters?.start_date}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      start_date: e.target.value,
                    });
                  }}
                />
                <label>Admission From Date</label>
              </div>
            </div>
          </div>

          {/* BUTTONS SAME AS YOURS */}
          <div className="row g-2 mt-3">
            <div className="col-6">
              <button
                className="btn btn-primary w-100"
                data-bs-dismiss="offcanvas"
              >
                Apply
              </button>
            </div>

            <div className="col-6">
              <button
                className="btn btn-outline-danger w-100"
                onClick={() =>
                  setFilters({
                    status: "",
                    search: "",
                    session_id: "",
                    start_date: "",
                    end_date: "",
                    created_by: "",
                    course_id: "",
                    sort_by: "",
                    sort_order: "",
                  })
                }
              >
                Reset
              </button>
            </div>

           

           
              <div className="col-4">
                <button
                  className="btn btn-outline-danger w-100"
                  onClick={() =>
                    printElement("printDiv")
                  }
                >
                  <i className="ri-printer-line"></i>
                </button>
              </div>
         
          </div>
        </div>
      </div>
    </>
  );
}
